import { ElementsIconProps } from '../components';

export const DivisionSlashIcon = (props: ElementsIconProps) => (
  <svg width="13" height="35" viewBox="0 0 13 35" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 34.716H4.664L12.848 0H8.184L0 34.716Z" fill="#169FFF" />
  </svg>
);
